import React, { useEffect } from "react"
import { useLoginContext } from "../components/context/LoginContext"
import { useNavigate } from "react-router-dom"

export default () => {
  const navigate = useNavigate()
  const { isLogined } = useLoginContext()

  useEffect(() => {
    if (isLogined) {
      navigate("/view", { replace: true })
      return
    } else {
      navigate("/login", { replace: true })
    }
  }, [isLogined, navigate])

  return <div style={{ minHeight: "100vh" }} />
}
